module.exports = __webpack_public_path__ + "dingbeauty/admin/img/member_avatar_female.3b62c903.png";